import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
//#region src/lib/utils.ts
/**
* DESIGN.md §1.3 type scale, as tailwind-merge sees it (CON-322).
*
* `text-*` is ambiguous: `text-red-500` is a colour, `text-label-md` is
* a font size. tailwind-merge's built-in `font-size` group only knows
* Tailwind's own t-shirt sizes (`text-sm`, `text-2xl`, …); every other
* `text-<word>` falls through to the `text-color` group, which matches
* anything. So `cn('text-text-on-action-1', 'text-label-md')` filed BOTH
* as colours, called them a conflict, and kept the last — deleting the
* colour.
*
* That is how the dashboard's primary buttons shipped black on black:
* the Button's `default` variant sets `text-text-on-action-1` (white)
* and its `default` size appends `text-label-md`, so every primary
* button rendered jet text on a jet fill. Registering the scale as font
* sizes puts each name on an exact node of tailwind-merge's lookup
* trie, which wins over the catch-all colour validator.
*
* Keep in sync with the `--text-*` entries in `styles/marketing.css`;
* `utils.unit.test.ts` asserts the two lists match.
*/
const TYPE_SCALE = [
	"h1",
	"h1-tab",
	"h1-mob",
	"h2",
	"h2-tab",
	"h2-mob",
	"h3",
	"h3-tab",
	"h3-mob",
	"h4",
	"h4-tab",
	"h4-mob",
	"h5",
	"h5-tab",
	"h5-mob",
	"h6",
	"h6-tab",
	"h6-mob",
	"body-xs",
	"body-sm",
	"body-sm-tab",
	"body-sm-mob",
	"body-md",
	"body-md-tab",
	"body-md-mob",
	"body-lg",
	"body-lg-tab",
	"body-lg-mob",
	"label-xs",
	"label-xs-tab",
	"label-sm",
	"label-sm-tab",
	"label-md",
	"label-md-tab",
	"label-lg",
	"label-lg-tab",
	"overline"
];
const twMerge = extendTailwindMerge({ extend: {
	theme: { radius: [...[
		"xxxs",
		"xxs",
		"xxl",
		"inset",
		"panel",
		"shell"
	]] },
	classGroups: { "font-size": [{ text: [...TYPE_SCALE] }] }
} });
function cn(...inputs) {
	return twMerge(clsx(inputs));
}
//#endregion
export { TYPE_SCALE, cn };
